import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
          精选文章
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          汇集业内专家深度研究，为您提供最前沿的合规知识与实用指南
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featured.map((article) => (
          <article key={article.slug} className="group">
            <Link
              to={`/article/${article.slug}`}
              className="block p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer h-full"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {article.date}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">
                  {article.readTime}
                </span>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {article.excerpt}
              </p>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}